import { GetOrderResData } from 'requests/RequestPayment';
import { convertPriceDisplay } from 'common/PriceConverter';
import { Hr } from 'components/atoms/Hr';
import classes from 'components/templates/override.module.scss';

export const usePaymentOverview = (order: GetOrderResData) => {
	type Props = {
		error?: string;
	};
	const PaymentOverview = (props: Props) => {
		const { error = '' } = props;
		if (!order) {
			return null;
		}
		return (
			<>
				{order.logo && (
					<>
						<div className={classes.paymentLogo}>
							<img src={order.logo} alt="" />
						</div>
						<Hr />
					</>
				)}
				<div className={`section-head ${order.logo ? classes.marginTop30 : ''}`}>
					<h1>お支払い方法の選択</h1>
				</div>
				{!!error && (
					<div className="error-box">
						<div className="error-box-in">
							<p>{error}</p>
						</div>
					</div>
				)}
				<div className="section-txt-box">
					<div className="txt">
						<div>すべての取引は安全で、暗号化されています。</div>
					</div>
				</div>
				<div className={classes.paymentOverview}>
					<span className={classes.paymentOverviewSpan}>金額をご確認の上決済方法をご選択ください</span>
					<div>
						<div className={classes.paymentOverviewRow}>
							<div className={classes.paymentOverviewHead}>商品代金：</div>
							<div className={classes.paymentOverviewCol}>{convertPriceDisplay(order.net_amount)}</div>
						</div>
						<div className={classes.paymentOverviewRow}>
							<div className={classes.paymentOverviewHead}>送料/手数料：</div>
							<div className={classes.paymentOverviewCol}>{convertPriceDisplay(order.postage)}</div>
						</div>
						<div className={classes.paymentOverviewRow}>
							<div className={classes.paymentOverviewHead}>割引など：</div>
							<div className={classes.paymentOverviewCol}>{convertPriceDisplay(order.discount)}</div>
						</div>
						<div className={classes.paymentOverviewRow}>
							<div className={classes.paymentOverviewHead}>消費税：</div>
							<div className={classes.paymentOverviewCol}>{convertPriceDisplay(order.tax)}</div>
						</div>
					</div>
					<div className={classes.paymentOverviewHr}>
						<Hr />
					</div>
					<div className={classes.paymentOverviewRow}>
						<div className={`${classes.paymentOverviewHeadSum} ${classes.paymentOverviewHead}`}>お支払金額合計：</div>
						<div className={`${classes.paymentOverviewColSum} ${classes.paymentOverviewCol}`}>
							{convertPriceDisplay(order.capture_amount)}
						</div>
					</div>
					<span className={classes.paymentOverviewNote}>{order.remarks}</span>
				</div>
			</>
		);
	};

	return {
		PaymentOverview,
	};
};
